/* istanbul ignore file */
import { createRouteRef } from "@backstage/core-plugin-api";

export const rootRouteRef = createRouteRef({
  id: "compensation-forge",
});
